interface Props {
  [key: string]: any
}

export default function HomSettingsIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props

  return (
    <svg fill="none" viewBox="0 0 48 48" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24 35.5C30.3513 35.5 35.5 30.3513 35.5 24C35.5 17.6487 30.3513 12.5 24 12.5C17.6487 12.5 12.5 17.6487 12.5 24C12.5 30.3513 17.6487 35.5 24 35.5Z"
        fill="url(#hom-settings_paint0_linear)"
      />
      <path
        d="M24 31C27.866 31 31 27.866 31 24C31 20.134 27.866 17 24 17C20.134 17 17 20.134 17 24C17 27.866 20.134 31 24 31Z"
        fill="#A481D1"
      />
      <path
        d="M43.407 19.2429C41.018 19.2139 38.705 17.9689 37.424 15.7499C36.191 13.6139 36.216 11.1009 37.262 9.0569C35.137 7.1699 32.62 5.7179 29.832 4.8689C28.577 6.7559 26.435 7.9999 24 7.9999C21.565 7.9999 19.423 6.7559 18.169 4.8689C15.381 5.7179 12.864 7.1699 10.739 9.0569C11.785 11.1009 11.81 13.6139 10.577 15.7499C9.296 17.9689 6.983 19.2139 4.594 19.2429C4.22 20.7699 4 22.3579 4 23.9999C4 25.2839 4.133 26.5349 4.364 27.7519C6.833 27.7009 9.255 28.9599 10.577 31.2499C11.945 33.6199 11.764 36.4539 10.357 38.5949C12.439 40.5419 14.93 42.0509 17.697 42.9699C18.827 40.6239 21.221 38.9999 24 38.9999C26.779 38.9999 29.173 40.6239 30.303 42.9709C33.07 42.0519 35.561 40.5429 37.643 38.5959C36.236 36.4549 36.055 33.6209 37.423 31.2509C38.745 28.9609 41.166 27.7019 43.636 27.7529C43.867 26.5349 44 25.2839 44 23.9999C44 22.3579 43.78 20.7699 43.407 19.2429ZM24 34.4999C18.201 34.4999 13.5 29.7989 13.5 23.9999C13.5 18.2009 18.201 13.4999 24 13.4999C29.799 13.4999 34.5 18.2009 34.5 23.9999C34.5 29.7989 29.799 34.4999 24 34.4999Z"
        fill="#7D38D6"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="hom-settings_paint0_linear"
          x1="32.012"
          x2="15.881"
          y1="32.012"
          y2="15.881"
        >
          <stop stopColor="white" />
          <stop offset="0.242" stopColor="#F2F2F2" />
          <stop offset="1" stopColor="#CCCCCC" />
        </linearGradient>
      </defs>
    </svg>
  )
}
